import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import RoleActions from '../../../../reducers/modules/user/role/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'user-access/role'

export default class RoleMiddleware {
  static beforeAssign(data,id){
    return (dispatch) => {
      dispatch(RoleActions.beforeAssign());
      RoleMiddleware.assign(dispatch, data,id);
    };
  }

  static assign(dispatch,data,id){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url:url+'/assign/'+id,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RoleActions.afterAssign(response.data.result));
          RoleMiddleware.alertHendler(dispatch, response, true, 'Save Data Successfully', 'success')
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error)
      });
  }


  static beforeRevoke(data,id){
    return (dispatch) => {
      dispatch(RoleActions.beforeRevoke());
      RoleMiddleware.revoke(dispatch, data,id);
    };
  }

  static revoke(dispatch,data,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url:url+'/revoke/'+id,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RoleActions.afterRevoke(response.data.result));
          RoleMiddleware.alertHendler(dispatch, response, true, 'Save Data Successfully', 'success')
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error)
      });
  }

  static showAssign(params){
    return (dispatch) => {
        dispatch(RoleActions.beforeshowAssign());
        RoleMiddleware.showCurrentAssign(dispatch, params);
      };
  }

  static showCurrentAssign(dispatch,id){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url:url+'/assign/'+id,
        responseType: 'json',
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RoleActions.showAssign(response.data.result));
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error)
      });
  }

  static create(params){
    return (dispatch) => {
      dispatch(RoleActions.create());
      
    };
  }

  static update(params){
    return (dispatch) => {
      RoleMiddleware.showOne(dispatch, params);
      dispatch(RoleActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(RoleActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(RoleActions.process());
          RoleMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(RoleActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(RoleActions.view());
        RoleMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(RoleActions.submit());
        RoleMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(params,post,navigate){
    return (dispatch) => {
        dispatch(RoleActions.submit());
        RoleMiddleware.saveUpdate(dispatch, params, post,navigate);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(RoleActions.delete());
        RoleMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      RoleMiddleware.showHelper(dispatch,params);
      };
  }

 
  
  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${RoleMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(RoleActions.list(response.data.result));
          }
        })
        .catch((error) => {
          RoleMiddleware.alertHendler(dispatch,error)
        });
  }

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RoleActions.view(response.data.result));
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(RoleActions.process(),RoleMiddleware.showlist(dispatch, params));
          RoleMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,navigate){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          Swal.fire({
            title:'Success',
            html:"Create Role Successfully",
            icon:'success',
            showConfirmButton:true,
          })
          .then((result)=>{
            if(result.isConfirmed){
              dispatch(RoleActions.success());
              dispatch(RoleActions.reset());
              navigate("/user/admin/role/assign/"+response.data.result.id)
            }
        })
          
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post, navigate){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${RoleMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          Swal.fire({
            title:'Success',
            html:"Update Role Successfully",
            icon:'success',
            showConfirmButton:true,
          })
          .then((result)=>{
            if(result.isConfirmed){
              dispatch(RoleActions.success());
              dispatch(RoleActions.reset());
              navigate("/user/admin/role/assign/"+response.data.result.id)
            }
        })
        }
      })
      .catch((error) => {
        RoleMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(RoleActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(RoleActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
